import { LOADING, NOT_LOGGED_IN, STATUS_NOT_LOADED } from "../../api/constant";

export const types = {
  AUTH_LOGOUT: "auth_logout",
  CHANGE_INPUT_LOGIN_FORM: "change_input_login_form",
  NOT_LOGGED_IN_FETCH: "not_logged_id_fetch",
  LOGGED_IN_FETCH: "logged_in",
  LOADING_LOGGIN_FETCH: "loading_login_fetch",
  NOT_LOADED: "no_loaded",
  TOGGLE_PASSWORD: "toggle_password",
  RESET_TOKEN: "reset_token",
};
export const initialState = {
  user: {},
  loginForm: {
    email: "",
    password: "",
  },
  showPassword: false,
  tokenReset: "",
  userStatus: STATUS_NOT_LOADED,
};
export const authReducer = (state, action) => {
  const {
    AUTH_LOGOUT,
    CHANGE_INPUT_LOGIN_FORM,
    NOT_LOGGED_IN_FETCH,
    LOGGED_IN_FETCH,
    LOADING_LOGGIN_FETCH,
    NOT_LOADED,
    TOGGLE_PASSWORD,
    RESET_TOKEN,
  } = types;
  switch (action.type) {
    case AUTH_LOGOUT:
      return { ...state, user: null, userStatus: NOT_LOGGED_IN };
    case NOT_LOGGED_IN_FETCH:
      return { ...state, userStatus: NOT_LOGGED_IN };
    case LOADING_LOGGIN_FETCH:
      return { ...state, userStatus: LOADING };
    case NOT_LOADED:
      return { ...state, userStatus: STATUS_NOT_LOADED };
    case TOGGLE_PASSWORD:
      return { ...state, showPassword: !state.showPassword };
    case LOGGED_IN_FETCH:
      return { ...state, userStatus: "LOGGED_IN", user: action.payload };
    case RESET_TOKEN:
      return { ...state, tokenReset: action.payload };
    case CHANGE_INPUT_LOGIN_FORM:
      return {
        ...state,
        loginForm: {
          ...state.loginForm,
          [action.payload.name]: action.payload.value,
        },
      };

    default:
      return state;
  }
};
